<template>
  <div id="followProDetail">
    <div id="C_content">
      <div class="C_container">
        <div class="C_title">
          <span class="Title_left"></span>项目跟进详情 共<span style="margin:0 10px; color: $selectedColor" class="colorH">{{ total }}</span>条
          <div class="inline floatR" style="margin-left: 20px">
            <el-button type="primary" @click="$router.go(-1)">返回</el-button>
          </div>
        </div>
        <div class="inline form-group">
          <el-form :inline="true" class="inline">
            <el-form-item label="">
              <el-input
                style="width: 200px"
                clearable=""
                v-model="searchList.collectCompany"
                placeholder="请输入公司名称"
                @change="search"
                @clear="search"
              ></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-cascader
              placeholder="请选择地区"
                ref="refHandle"
                style="width: 150px"
                v-model="city_search"
                :options="city_data"
                :props="{ checkStrictly: true }"
                @change="handleChange"
                clearable
              ></el-cascader>
            </el-form-item>
            <el-form-item label="">
              <el-select
                size="small"
                style="width: 150px"
                placeholder="请选择行业"
                filterable
                clearable
                v-model="searchList.companyPrimaryIndustrie"
                @change="search"
              >
                <el-option
                  v-for="item in chain"
                  :key="item.yijihy"
                  :label="item.yijihy"
                  :value="item.yijihy"
                ></el-option>
              </el-select>
            </el-form-item>

          
          <el-form-item label="">
          <el-date-picker
            v-model="value2"
            type="daterange"
            align="right"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="DateTimeChange"
            :clearable="false"
          >
          </el-date-picker>
        </el-form-item>
            <el-form-item label=""  v-if="unitJudge()&&proleaderJudge()">

          <el-select
            v-model="searchList.firstName"
            placeholder="一级部门"
            style="width: 160px"
            filterable
            clearable=""
            @change="firstChange()"
          >
            <el-option
              v-for="item in deptmentList"
              :key="item.label"
              :label="item.remark"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
            <el-form-item label=""  v-if="unitJudge()&&proleaderJudge()">

          <el-select
            v-model="searchList.secondName"
            placeholder="二级部门"
            style="width: 160px"
            filterable
            clearable=""
            @change="secChange()"
            :disabled="searchList.firstName == ''"
          >
            <el-option
              v-for="item in secdeptmentList"
              :key="item.label"
              :label="item.value"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
            <el-form-item label=""  v-if="unitJudge()">

          <el-select
            v-model="searchList.otherMobile"
            placeholder="下属"
            style="width: 160px"
            filterable
            clearable=""
            :disabled="searchList.firstName != ''&&searchList.secondName ==''"
            @change="search()"
          >
            <el-option
              v-for="item in PeopleList"
              :key="item.label"
              :label="item.realName"
              :value="item.mobile"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label=""  v-if="leaderJudge()">
              <el-select
                size="small"
                style="width: 150px"
                placeholder="请选择外部客户"
                filterable
                clearable
                v-model="searchList.foreignName"
                @change="search()"
              >
                <el-option
                  v-for="item in foreignList"
                  :key="item.realName"
                  :label="item.realName"
                  :value="item.realName"
                ></el-option>
              </el-select>
            </el-form-item>
        <el-form-item
                label="外部客户："
                v-if="leaderJudge()"
              >
                <el-switch
                  @change="search()"
                  v-model="foreignType"
                  active-color="#cf111b"
                ></el-switch>
              </el-form-item>

              <el-button @click="search()" class="inlineBlock" type="primary">查询</el-button>
        </el-form>


        </div>


        <div class="table-wrapper">
          <el-table
            stripe
            :data="tableData"
            id="toChange"
            style="width: 100%"
            empty-text="不存在相关企业!"
            @selection-change="selectionChange"
            >
            <!-- :row-class-name="tableRowClassName" -->
            <el-table-column
              prop="collectCompany"
              label="企业名称"
              width="300"
              align="center"
            >
              <template slot-scope="scope">
                <router-link
                  target="_blank"
                  tag="a"
                  class="toChange"
                  style="color: #606266; text-decoration: none"
                  :to="{
                    path: '/CompanyDetails',
                    query: { name: Base64.encode(scope.row.collectCompany) },
                  }"
                >
                  <p size="medium" v-html="scope.row.collectCompany"></p>
                </router-link>
              </template>
            </el-table-column>

              <el-table-column
                prop="userName"
                align="center"
                label="开发人"
              ></el-table-column>
              <el-table-column
                prop="developmentStatus"
                align="center"
                label="跟进阶段"
              ></el-table-column>
              <el-table-column
                prop="clientGrade"
                align="center"
                label="客户等级"
              >
              <template slot-scope="scope">
                    {{
                      getString(scope.row.clientGrade) 
                        
                    }}
                  </template>
            
            </el-table-column>
              <el-table-column
                prop="hf"
                align="center"
                label="跟进记录"
                key="hf"
              >
                <template slot-scope="scope">
                  <el-button
                    @click="
                     openCallback(scope.row.id, scope.row.collectCompany, scope.row)
                    "
                    type="text"
                    size="medium"
                    >跟进记录({{ scope.row.recount ? scope.row.recount : 0 }})</el-button
                  >
                </template>
              </el-table-column>
              <el-table-column
                prop="count"
                align="center"
                column-key="id"
                label="对接人"
              >
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="medium "
                    @click="openDialog(scope.row)"
                  >
                    联系人({{ scope.row.count ? scope.row.count : 0 }})
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column
                prop="nextVisitTime"
                align="center"
                label="下次回访时间"
                width="140"
              >
                <template slot-scope="{ row }">{{
                  row.nextVisitTime ? row.nextVisitTime.substring(0, 10) : "-"
                }}</template>
              </el-table-column>

              <el-table-column prop="days" align="center" label="温馨提示">
                <template slot-scope="scope">
                  <span
                    class="colorY"
                    v-if="scope.row.days == '距离回访还差1天'"
                  >
                    {{ scope.row.days }}
                  </span>
                  <span
                    class="colorH"
                    v-else-if="scope.row.days == '距离回访还差0天'"
                  >
                    今日需回访！
                  </span>
                  <span class="rrr" v-else> {{ scope.row.days }} </span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="操作" align="center" width="160" v-if="unitCode == 3">
                <template slot-scope="scope">
                  <el-button
                  v-if="scope.row.mobile == mobile"
                        @click="openChange(scope.row)"
                        type="text"
                        size="medium"
                        >跟进阶段</el-button
                      >

                </template>
              </el-table-column> -->

              
          </el-table>
        </div>
        <!-- </div> -->
        <!-- 分页dom start -->
        <div id="Pagination" v-show="total > 10">
          <el-pagination
            layout="prev, pager, next"
            prev-text="上一页"
            next-text="下一页"
            @current-change="handleCurrentChange"
            :page-size="10"
            :current-page="searchList.pageNumber"
          ></el-pagination>
          <el-button
            size="small"
            :disabled="suibian"
            class="paginationsy"
            @click="paginationsy"
            >首页</el-button
          >
        </div>
      </div>
    </div>
    <el-dialog
      title="意向客户跟进记录"
      center
      :show-close="false"
      v-if="callbackVisible"
      id="chainMAPS"
      @close="callBackClose"
      :visible.sync="callbackVisible"
      width="1200px"
    >
      <div class="close" @click="callBackClose">×</div>
      <favoriteListCallback
        :close="Fun"
        :fiveId="fiveId"
        :fiveName="fiveName"
        :synId="synId"
        :changeData="changeData"
      ></favoriteListCallback>
    </el-dialog>
    <el-dialog
      title
      :visible.sync="dialogTableVisible"
      v-if="dialogTableVisible"
      @close="GovernmentinfoList"
      width="1400px"
    >
      <favoritePhone :coolId="coolId" :company="company"></favoritePhone>
    </el-dialog>

    <!-- <el-dialog
      title="意向客户跟进阶段"
      center
      :show-close="false"
      v-if="changeVisible"
      id="chainMAPS"
      :visible.sync="changeVisible"
      width="800px"
    >
      <div class="close" @click="changeVisible = false">×</div>
      <favoriteChange
        :close="Fun"
        :changeData="changeData"
        :talkOptions="talkOptions"
      ></favoriteChange>
    </el-dialog> -->
  </div>
</template>
  <script>
import {
  deptment,
  secdeptment,
  deptmentPeople,
  projectFollowList,
  foreign,
} from "../../api/followPro/followPro";
import favoriteListCallback from "../Firstpage/favoriteListCallback.vue";
import favoritePhone from "../Firstpage/favoritePhone";
import favoriteChange from "../Firstpage/favoriteChange";
export default {
  components: {
    favoriteListCallback,
    favoritePhone,
    favoriteChange,
  },
  data() {
    return {
      deptmentList: [],
      secdeptmentList: [],
      PeopleList: [],
      suibian: false,
      tableData: "",
      city_search: "",

      searchList: {
        companyPrimaryIndustrie: "",
        collectCompany: "",
        companyProvince: "",
        companyCity: "",
        companyArea: "",
        startTime: "",
        endTime: "",
        firstName: "",
        secondName: "",
        otherMobile: "",
        pageSize: 10,
        pageNumber: 1,
        foreignName:'',
        foreignType:false,
      },
      foreignType:false,

      total: 0,
      value2: [],
      callbackVisible: false,
      fiveId: "",
      fiveName: "",
      synId: "",
      dialogTableVisible: false,
      company: "",
      coolId: "",
      foreignList: [],
      city_data: [],
      unitCode:'',
      changeData:"",
      changeVisible:false,
    };
  },
  mounted() {
    this.mobile =  localStorage.getItem("mobile");
    this.unitCode =  localStorage.getItem("unitCode");
    this.isLeader =  localStorage.getItem("isLeader");
    let list = JSON.parse(this.$route.query.list)
    console.log(this.searchList)
    this.searchList = Object.assign(this.searchList , list)

    this.searchList.firstName ? this.getsecDeptment() : "";
    this.searchList.secondName ? this.getPeople() : "";
    
    console.log(list)
    this.getDate();
    this.getDeptment();
    this.getPeople();
    this.getChain();
    this.citylist();
  },
  methods: {
    //跟进阶段弹框
    openChange(data) {
      console.log("ccccc", data);
      this.changeData = JSON.stringify(data);
      this.changeVisible = true;
    },
    getString(str) {
      if(str){
        let index = str.indexOf("（"); // 括号区分中文英文，index=5--即：获取到第一个括号的索引位置
      let resolve = index !=-1? str.substring(0, index):str; // 获取到第一个括号前面的所有字符
      console.log(resolve); // abcde
      return resolve;
      }
        return str
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.color === "red") {
        return "warning-row";
      } else if (row.color === "yellow") {
        return "success-row";
      }
      return "";
    },
    leaderJudge(){
      // console.log(this.unitJudge,"UNIT判断")
      if(this.unitJudge() && this.unitCode !=3){
        return true
      }
      return false
    },
    unitJudge(){
        if( this.unitCode !=9&& this.unitCode !=15){
            return true
        }
        return false
    },
    proleaderJudge(){
        if( this.unitCode ==3&& this.isLeader !=1){
            return false
        }
        return true
    },
    handleChange(value) {
      var self = this;
      self.searchList.companyProvince = value[0] ? value[0] : "";
      self.searchList.companyCity = value[1] ? value[1] : "";
      self.searchList.companyArea = value[2] ? value[2] : "";
      self.search();
    },
        //省市
     citylist() {
      var self = this;
      this.axios({
        url: this.api.LXshengshiquapi,
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }).then((res) => {
        // console.log(JSON.stringify(res.data.data));
        self.city_data = res.data.data;
      });
    },
    //查询一级
    getChain() {
      var self = this;
      let params = {
        oldhangye: self.IsZz ? "1" : "",
      };
      this.axios({
        url: this.api.EsExporyijihyapi,
        data: this.$qs.stringify(params),
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }).then((res) => {
        self.chain = res.data.data;
      });
    },

    //搜索
    search() {
      var self = this;
      self.searchList.pageNumber = 1;
      self.GovernmentinfoList();
    },

    //打开弹窗
    openDialog(val) {
      var self = this;
      self.dialogTableVisible = true;
      self.coolId = val.id;
      self.company = val.collectCompany;
    },

    callBackClose() {
      this.callbackVisible = false;
      this.GovernmentinfoList();
    },
    Fun(msg) {
      var self = this;
      console.log(msg);
      self.dialogVisible = false;
      self.changeVisible = false;
      self.GovernmentinfoList();
    },
    //回访弹窗
    openCallback(fiveId, fiveName,data, synId ) {

      var self = this;
      self.callbackVisible = true;
      this.changeData = JSON.stringify(data);
      self.fiveId = fiveId;
      self.fiveName = fiveName;
      self.synId = synId ? synId : "";
      
    },
    firstChange() {
      this.searchList.secondName = "";
      this.searchList.firstName ? this.getsecDeptment() : "";
      this.search();
    },
    secChange() {
      this.searchList.otherMobile = "";
      this.getPeople();
      this.search();
    },
    //获取一级部门和外部客户
    async getDeptment() {
      var self = this
      let res = await deptment();
      self.deptmentList = res.data;
      let res1 = await foreign();
      self.foreignList = res1.data;
    },
    //获取二级部门
    async getsecDeptment() {
      let params = {
        firstName: this.searchList.firstName,
      };
      let res = await secdeptment(params);
      this.secdeptmentList = res.data;
    },
    //获取下属
    async getPeople() {
      let params = {
        secName: this.searchList.secondName,
      };
      let res = await deptmentPeople(params);
      this.PeopleList = res.data;
    },
    //详情列表
    GovernmentinfoList() {
      var self = this;
      var right = document.getElementsByClassName("btn-next");
      right[0].disabled = "";
      let params = this.searchList;
      params.foreignType =self.foreignType == true ? 1 : ''
      projectFollowList(params).then((res) => {
        console.log(res, "详情列表");
        self.tableData = res.data.list;
        self.total = res.data.totalRow;
        var cot = Math.ceil(self.total / 10);
        if (cot <= self.searchList.pageNumber) {
          right[0].disabled = "disabled";
        } else if (self.searchList.pageNumber == 1) {
          self.suibian = true;
        }
      });
    },

    handleCurrentChange(val) {
      var self = this;

      self.searchList.pageNumber = val;
      self.suibian = false; //是否禁用首页按钮
      self.GovernmentinfoList();
    },
    paginationsy() {
      if (this.searchList.pageNumber === 1) {
      } else {
        this.handleCurrentChange(1);
      }
    },

    getDate() {
      // const self = this;
      // this.searchList.endTime = self.formatDateTime(new Date());
      // this.searchList.startTime = new Date();
      // this.searchList.startTime.setTime(
      //   this.searchList.startTime.getTime() - 3600 * 1000 * 24 * 30
      // );
      // this.searchList.startTime = self.formatDateTime(
      //   this.searchList.startTime
      // );
      var str = this.searchList.startTime + "," + this.searchList.endTime;
      this.value2 = str.split(",");
      this.search();
    },

    formatDateTime(date) {
      if (date == "" || !date) {
        return "";
      }
      var date = new Date(date);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      return y + "-" + m + "-" + d;
    },
    DateTimeChange(val) {
      var self = this;
      var start = val[0];
      var end = val[1];
      if (start > end) {
        this.$message.error("查询开始时间不得早于查询结束时间");
      } else {
        self.searchList.startTime = start;
        self.searchList.endTime = end;
        this.search();
      }
    },
  },
};
</script>
  <style lang="scss">
.el-table__body-wrapper::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
.el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #ccc;
  border-radius: 3px;
}
</style>
  <style lang="scss" >
#followProDetail {
  .el-table .warning-row {
    background: #f56c6c;
    td {
      background: none;
    }
  }

  .el-table .success-row {
    background: #ecba60;
    td {
      background: none;
    }
  }
  .el-form-item {
    margin-bottom: 0;
  }
  .form-group {
    margin: 10px 0 10px 20px;
  }
  .el-dialog__header {
    padding: 10px 20px;
    border-radius: 6px 6px 0 0;
  }
  .el-dialog {
    border-radius: 6px;
  }
  .el-dialog__headerbtn .el-dialog__close {
    color: #000;
  }
  .el-dialog__headerbtn .el-dialog__close:hover {
    color: $selectedColor;
  }
  .el-dialog__body {
    font-size: 20px;
    color: #000;
    padding: 0 0 20px;
  }
}
</style>
      